import { Base } from '../base-component';
import './social-feeds.component.scss';

export class SocialFeeds extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}

}


// WEBPACK FOOTER //
// ./components/social-feeds/social-feeds.component.ts